export type FilterOption = {
  value: string;
  label: string;
  count: number;
  selected: boolean;
  disabled: boolean;
  rating?: number;
};

export type FilterStrengthGroup = {
  levelLabel: string;
  options: FilterOption[];
};

export type FilterSection = {
  id: string;
  label: string;
  options: FilterOption[];
  strengthGroups?: FilterStrengthGroup[];
};
